import { LocalizedText } from "../i18n/LocalizedCopy";
import { useSourceLanguage } from "../i18n/LocalizedCopy";
import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n/LanguageContext";
import EternuaIcon from "./EternuaIcon";
import "./HomeTrustWelcome.css";

export const ETERNUA_WELCOME = "Bienvenue sur ton espace de confiance. Ici, chaque geste compte. Explore tes récompenses et partage ta confiance avec les autres.";
const actions = [
  { icon: "trust", label: "Confiance", to: "/confiance" },
  { icon: "gesture", label: "Chaque geste compte", to: "/mes-eternua/missions" },
  { icon: "trophy", label: "Récompenses", to: "/mes-eternua" },
  { icon: "share", label: "Partager", to: "/amis" },
];
export default function HomeTrustWelcome({ embedded = false }) {
  useSourceLanguage();
  const { t } = useI18n();
  return <section className={`et-home-trust${embedded ? " et-home-trust--embedded" : ""}`} aria-label={t("memberTrust.welcomeAria", "Bienvenue dans ton espace de confiance")}>
    <div className="et-home-trust__welcome"><EternuaIcon name="infinity" /><p>{<LocalizedText source={t("memberTrust.welcome", ETERNUA_WELCOME)} />}</p></div>
    <nav className="et-home-trust__actions" aria-label={t("memberTrust.nav", "Explorer ton espace de confiance")}>
      {actions.map(action => <Link key={action.icon} to={action.to}><EternuaIcon name={action.icon} /><span>{<LocalizedText source={t(`memberTrust.action.${action.icon}`, action.label)} />}</span></Link>)}
    </nav>
  </section>;
}
